// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var UserIntention = function (x) {
    return x;
};
var tsBridgeUserIntention = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("UserIntention")("__brandUserIntention"));
    }
};
var writeUserIntention = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showUserIntention = Data_Show.showString;
var readUserIntention = Simple_JSON.readString;
var ordUserIntention = Data_Ord.ordString;
var newtypeUserIntention = {
    Coercible0: function () {
        return undefined;
    }
};
var makeUserIntention = UserIntention;
var eqUserIntention = Data_Eq.eqString;
export {
    UserIntention,
    makeUserIntention,
    unwrap,
    newtypeUserIntention,
    eqUserIntention,
    ordUserIntention,
    showUserIntention,
    readUserIntention,
    writeUserIntention,
    tsBridgeUserIntention
};
//# sourceMappingURL=index.js.map
